<template>
  <div class="profile">
    <div class="has-text-centered is-centered">
      <p class="title is-3" style="">
        Attendee Details
      </p>
    </div>
    <b-message type="is-info is-light" class="my-3">
      Please ensure that your name, date of birth, and gender match your government issued ID.
    </b-message>
    <b-notification type="is-danger is-light" class="my-3" v-if="validationErrors.length > 0">
      <h4 class="is-size-5">Please correct the following errors:</h4>
      <div class="content">
        <ul>
          <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError }}</li>
        </ul>
      </div>
    </b-notification>
    <div class="columns is-mobile">
      <div class="column sect">
        <b-field label="First Name">
          <b-input v-model="profiler.firstName" required validation-message="Please enter a valid name"
                   pattern="[a-zA-Z]*"></b-input>
        </b-field>
        <b-field label="Middle Name (optional)">
          <b-input v-model="profiler.middleName" validation-message="Please enter a valid name"
                   pattern="[a-zA-Z]*"></b-input>
        </b-field>
        <b-field label="Last Name">
          <b-input v-model="profiler.lastName" required validation-message="Please enter a valid name"
                   pattern="[a-zA-Z]*"></b-input>
        </b-field>
        <b-field label="Date of Birth" >
          <b-input v-model="profiler.dateOfBirth" placeholder="yyyy-mm-dd" v-cleave="masks.dob" required></b-input>
        </b-field>
        <b-field label="Gender">
          <b-select v-model="profiler.gender" placeholder="Select Gender"  expanded>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Non-Binary">Non-Binary</option>
          </b-select>
        </b-field>
        <b-field label="Mobile Phone">
          <b-input v-model="profiler.mobilePhone" v-cleave="masks.phone" required></b-input>
        </b-field>
        <b-field label="Email">
          <b-input v-model="profiler.email" type="email" disabled></b-input>
        </b-field>
        <b-field label="TSA PreCheck™ Number (optional)">
          <b-input v-model="profiler.tsaPrecheckNumber"></b-input>
        </b-field>

      </div>
    </div>
    <div style=" text-align: center;" class="mb-1">
      <b-button size=""
                type="is-light" inverted outlined
                @click="proceed()" style="margin:auto; width: 30%">
        <h5>Save Details</h5>
      </b-button>
    </div>
  </div>
</template>

<script>
  import meetingsMixin from "@/mixins/meetingsMixin";
  import Cleave from 'cleave.js'
  const cleave = {
    name: 'cleave',
    bind(el, binding) {
      const input = el.querySelector('input')
      input._vCleave = new Cleave(input, binding.value)
    },
    unbind(el) {
      const input = el.querySelector('input')
      input._vCleave.destroy()
    }
  }

  export default {
    directives: { cleave },
    name: 'Profile',
    mixins: [meetingsMixin],
    data: function () {
      return {
        profiler: {},
        origProfile: {},
        icon: "alpha-i-circle",
        validationErrors: [],
        masks: {
          creditCard: { creditCard: true },
          numeral: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            prefix: '$ '
          },
          date: {
            date: true,
            datePattern: ['m', 'y']
          },
          dob: {
            date: true,
            delimiter: '-',
            datePattern: ['Y', 'm', 'd']
          },
          phone: {
            phone: true,
            phoneRegionCode: "US",
            delimiter: "-"
          }
        }
      }
    },
    props: {
    },
    methods: {
      proceed(){
        let isValid = this.validateForm()

        if (!isValid) return

        this.$store.commit('meetings/ADD_MEETING_PROFILE', this.profiler)
        this.$store.commit('meetings/MEETING_PROFILE_SET', true)
        this.saveRegistrationProfile()
        this.setRegistrationProfile()
        this.meetingRouter()

      },
      validateForm() {
        // console.log('validate form')

        var errors = []

        if (!this.profiler.firstName){
          errors.push("First name is required")
        }

        if (!this.profiler.lastName){
          errors.push("Last name is required")
        }

        if (!this.profiler.dateOfBirth){
          errors.push("Date of Birth is required")
        }

        if (!this.profiler.gender){
          errors.push("Gender is required")
        }

        if (!this.profiler.mobilePhone){
          errors.push("Mobile phone is required")
        }

        this.validationErrors = errors

        if (errors.length > 0){
          return false
        }

        return true
      },
      saveRegistrationProfile(){
        var raw = {
          "contactId": this.profiler.id,
          "firstName": this.profiler.firstName,
          "middleName": this.profiler.middleName,
          "lastName": this.profiler.lastName,
          "nickname": this.profiler.nickName,
          "mobilePhone": this.profiler.mobilePhone,
          "gender": this.profiler.gender,
          "dateOfBirth": this.profiler.dateOfBirth,
          "tsaPrecheckNumber": this.profiler.tsaPrecheckNumber
        }
        this.$app.huddleLabsServerCall('profile/travel-profile/save', raw)
      },
      setRegistrationProfile(){
        var raw = {
          "id": this.$store.state.meetings.meetingInfo.attendeeId,
          "events": [
            "profileSaved",
          ]
        }
        this.$app.huddleLabsServerCall('meetings/attendee/save', raw)

      }
    },
    mounted () {
      this.profiler = this.$store.getters['travellersAndTrips/getCurrentTravellerProfile'];
    }
  }
</script>

<style lang="scss" scoped>
  // mobile
  @media screen and (max-width: 1023px) {

    .profile {
      margin: auto;

    }

  }
  // pc
  @media screen and (min-width: 1024px) {
    .profile {
      margin: auto;
    }
  }
</style>
